import { BUILD_VERSION } from '@/generated/buildVersion'

const CHECK_INTERVAL_MS = 60 * 1000
let lastCheckedAt = 0
let pendingCheck: Promise<boolean> | null = null
let reloadStarted = false

function reloadWithVersion(version: string): void {
  if (reloadStarted || typeof window === 'undefined') return
  reloadStarted = true
  const url = new URL(window.location.href)
  url.searchParams.set('_build', version)
  window.location.replace(url.toString())
}

export function ensureLatestBuild(force = false): Promise<boolean> {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return Promise.resolve(true)
  if (!force && Date.now() - lastCheckedAt < CHECK_INTERVAL_MS) return Promise.resolve(true)
  if (pendingCheck) return pendingCheck

  pendingCheck = window.fetch(`/build-version.json?t=${Date.now()}`, {
    cache: 'no-store',
    credentials: 'same-origin'
  })
    .then(response => response.ok ? response.json() : null)
    .then(payload => {
      lastCheckedAt = Date.now()
      const remoteVersion = String(payload && payload.version || '').trim()
      if (remoteVersion && remoteVersion !== BUILD_VERSION) {
        reloadWithVersion(remoteVersion)
        return false
      }
      return true
    })
    .catch(error => {
      console.warn('Build version check failed:', error)
      return true
    })
    .finally(() => {
      pendingCheck = null
    })

  return pendingCheck
}

export function installBuildVersionGuard(): void {
  if (typeof window === 'undefined') return
  const check = () => {
    ensureLatestBuild(true)
  }
  window.addEventListener('focus', check)
  window.addEventListener('pageshow', check)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check()
  })
  window.setInterval(check, 5 * 60 * 1000)
}

